import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileSignature } from 'lucide-react';
import { bsiInternetBankApi } from '@/lib/banks/bsi/api';
import { bsiServicePath } from './helpers';

type Props = {
  className?: string;
  /** اگر از بیرون تعداد را پاس دهید، درخواست جدا زده نمی‌شود */
  signableCount?: number;
  onNavigatePending?: () => void;
};

export function usePendingSignSummary(enabled = true) {
  const [signableCount, setSignableCount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const refresh = React.useCallback(async () => {
    if (!enabled) return 0;
    setLoading(true);
    try {
      const res = await bsiInternetBankApi.pendingTransfersSummary();
      const count = res.data?.signable_count ?? 0;
      setSignableCount(count);
      return count;
    } catch {
      return 0;
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  React.useEffect(() => {
    if (!enabled) return;
    void refresh();
  }, [enabled, refresh]);

  return { signableCount, loading, refresh, setSignableCount };
}

const BsiPendingSignBanner: React.FC<Props> = ({ className, signableCount: externalCount, onNavigatePending }) => {
  const navigate = useNavigate();
  const { signableCount: fetchedCount } = usePendingSignSummary(externalCount == null);
  const signableCount = externalCount ?? fetchedCount;

  if (signableCount <= 0) return null;

  return (
    <button
      type="button"
      onClick={() => {
        if (onNavigatePending) onNavigatePending();
        else navigate(bsiServicePath('pending'));
      }}
      className={`flex w-full items-center gap-3 rounded-xl border border-amber-300 bg-gradient-to-l from-amber-50 to-orange-50 px-4 py-3 text-start shadow-sm transition hover:from-amber-100 hover:to-orange-100 ${className ?? ''}`}
    >
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-500 text-white shadow">
        <FileSignature className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-amber-950">{signableCount} تراکنش در انتظار امضا</p>
        <p className="text-xs text-amber-800">برای تکمیل انتقال، امضای نهایی را بزنید</p>
      </div>
      <span className="rounded-lg bg-amber-500 px-2.5 py-1 text-xs font-medium text-white">رفتن</span>
    </button>
  );
};

export default BsiPendingSignBanner;
